import React from 'react';
import {
  Dialog,
  Slide,
  IconButton,
  DialogContent as DialogContentMui,
} from '@mui/material';
import { TransitionProps } from '@mui/material/transitions/transition';
import styled from 'styled-components';
import CloseIcon from '@mui/icons-material/Close';
import TrueImpactButton from 'shared/design-system/components/TrueImpactButton';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import {
  GroupedIndicators,
  Indicator,
  IndicatorGroups,
  SelectedIndicators,
} from './GroupedIndicators';

const Transition = React.forwardRef(
  (
    props: TransitionProps & { children: React.ReactElement },
    ref: React.Ref<unknown>,
  ) => <Slide direction="up" ref={ref} {...props} children={props.children} />,
);

interface ModalImpactsProps {
  open: boolean;
  onlyShowStageId?: number;
  beneficiaryTerm?: string;
  onClose: () => unknown;
  onChange: (indicator: Indicator) => unknown;
  indicators: IndicatorGroups;
  selected: SelectedIndicators;
}

const ModalImpacts: React.FC<ModalImpactsProps> = ({
  open,
  onClose,
  onChange,
  indicators,
  beneficiaryTerm,
  selected,
  onlyShowStageId,
}) => {
  return (
    <DialogWrapper
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      maxWidth="lg"
    >
      <DialogContent>
        <div className="content">
          <p className="title-3">
            Impact Indicators
            <IconButton
              className="icon"
              onClick={onClose}
              color="primary"
              component="span"
            >
              <CloseIcon />
            </IconButton>
          </p>
          <GroupedIndicators
            selected={selected}
            indicators={indicators}
            handleChange={onChange}
            onlyShowStageId={onlyShowStageId}
            beneficiaryTerm={beneficiaryTerm}
          />
        </div>
      </DialogContent>
      <div className="bottom">
        <TrueImpactButton onClick={onClose} variant="primary-large">
          Done
        </TrueImpactButton>
      </div>
    </DialogWrapper>
  );
};

export default ModalImpacts;

const DialogWrapper = styled(Dialog)`
  .bottom {
    padding: ${SPACERS.small};
    background-color: ${COLORS.greyLightest};
  }
`;

const DialogContent = styled(DialogContentMui)`
  padding: 20px;
  min-height: 600px;
  @media only screen and (max-height: 650px) {
    min-height: 100%;
  }
  .icon {
    float: right;
    svg {
      font-size: 32px;
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    min-width: 800px;
    @media only screen and (max-width: 850px) {
      min-width: 100%;
    }
    .title-3 {
      color: #48596b;
      font-weight: 700;
      font-size: 24px;
      margin-block-start: 0px;
      margin-block-end: 0px;
    }
    .regular-3 {
      color: #566778;
      font-weight: 400;
      font-size: 16px;
      margin-block-start: 0px;
      margin-block-end: 16px;
    }
  }
  .container {
    overflow: auto;
    padding: ${SPACERS.small} 0;
  }
`;
